import { render, staticRenderFns } from "./CategoryEditSidebar.vue?vue&type=template&id=2abd358a&scoped=true&"
import script from "./CategoryEditSidebar.vue?vue&type=script&lang=js&"
export * from "./CategoryEditSidebar.vue?vue&type=script&lang=js&"
import style0 from "./CategoryEditSidebar.vue?vue&type=style&index=0&id=2abd358a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2abd358a",
  null
  
)

export default component.exports